module.exports = __webpack_public_path__ + "img/id.6f13d3b5.png";